module.exports = __webpack_public_path__ + "static/massage-73b82e905a17272d9c85bca39fbcea91.png";